import React, { useEffect } from 'react';

import { useQuery } from 'react-query';

import { fetchAccountCohortPreview } from '../api';
import { ACCOUNT_COHORT_PREVIEW_QUERY_KEY } from '../constants';
import { SelectedAccount } from '../types';

type AccountCohortPreviewProps = {
  cohortId: number;
  onSample: (sample: SelectedAccount[]) => void;
};

const AccountCohortPreview: React.FC<AccountCohortPreviewProps> = ({ cohortId, onSample }) => {
  const { data } = useQuery(
    [ACCOUNT_COHORT_PREVIEW_QUERY_KEY, cohortId],
    fetchAccountCohortPreview
  );

  useEffect(() => {
    if (data) {
      onSample(data.data.sample);
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return null;

  const { count, sample } = data.data;
  return (
    <div className="bg-gray-50 p-2 text-xs text-gray-500 rounded">
      <span className="font-semibold text-blue-700">
        {count} cuenta{count !== 1 ? 's' : ''}
      </span>{' '}
      {sample.length > 0 && (
        <span className="text-gray-400">
          (
          {sample
            .slice(0, 3)
            .map((a) => a.name)
            .join(', ')}
          {count > 3 && '…'})
        </span>
      )}
    </div>
  );
};

export default AccountCohortPreview;
